"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentSlideIndex = void 0;
/**
 * Returns current slide index after update.
 */
const getCurrentSlideIndex = ({
  currentSlideIndex,
  slidesCount
}) => currentSlideIndex >= slidesCount ? 0 : currentSlideIndex;
exports.getCurrentSlideIndex = getCurrentSlideIndex;
//# sourceMappingURL=getCurrentSlideIndex.js.map